module.exports = __webpack_public_path__ + "img/ic_32_gender_divers-active.fdb226d7.svg";